import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

type DeleteAgentFirmUserParams = {
  agentFirmId: string;
  userId: string;
};

export async function deleteAgentFirmUser({
  agentFirmId,
  userId,
}: DeleteAgentFirmUserParams) {
  const response = await fetcher(
    `${API_BASE_PATH}/${agentFirmId}/users/${userId}`,
    {
      method: 'DELETE',
    }
  );

  if (!response.ok) {
    const data = await response.json();
    return {
      success: false,
      error: data?.message || 'Failed to delete agent firm user',
      statusCode: response.status,
    };
  }

  return {
    success: true,
  };
}
